import {i18n} from "../../shared/i18n";
const asArray = (value) => Array.isArray(value) ? value : [];

export const normalizeNotificationOperations = (payload = {}) => {
    const notifications = asArray(payload.notifications).map((item) => ({
        id: item.id ?? null,
        title: item.title || i18n.t("sections.inbox.p67"),
        text: item.text || "",
        status: item.not_status || item.status || i18n.t("sections.inbox.p68"),
    }));
    const count = (status) => notifications.filter((item) => item.status === status).length;
    return {
        notifications,
        actions: Boolean(payload.actions),
        pendingCount: Number.isFinite(Number(payload.pending_count)) ? Number(payload.pending_count) : count("Ожидает"),
        changedCount: Number.isFinite(Number(payload.changed_count)) ? Number(payload.changed_count) : count("Изменено"),
        rejectedCount: Number.isFinite(Number(payload.rejected_count)) ? Number(payload.rejected_count) : count("Отклонено"),
    };
};

export const canAcceptNotification = (notification, actions) =>
    Boolean(actions && Number(notification?.id) > 0 && notification?.status === "Ожидает");

export const notificationStatusTone = (status) => {
    if (status === "Изменено") return "success";
    if (status === "Отклонено") return "danger";
    if (status === "Ожидает") return "warning";
    return "neutral";
};

const reviewRows = (items, type, typeLabel) => asArray(items).map((item) => ({
    ...item,
    type,
    typeLabel,
}));

export const flattenReviews = (payload = {}) => [
    ...reviewRows(payload.branch_comments, "branch", i18n.t("sections.inbox.p69")),
    ...reviewRows(payload.personal_comments, "personal", i18n.t("sections.inbox.p70")),
];

export const filterReviews = (rows, {type = "all", status = "all", search = ""} = {}) => {
    const needle = String(search).trim().toLocaleLowerCase();
    return asArray(rows).filter((row) => {
        if (type !== "all" && row.type !== type) return false;
        if (status === "active" && row.is_canceled) return false;
        if (status === "canceled" && !row.is_canceled) return false;
        if (!needle) return true;
        return `${row.user || ""} ${row.text || ""}`.toLocaleLowerCase().includes(needle);
    });
};

export const validateCancelReason = (value) =>
    String(value ?? "").trim() ? "" : i18n.t("sections.inbox.p71");
